<template>
	<v-container>

		<v-app-bar app color="blue">
		
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>
			<v-toolbar-title class="white--text">
				<span class="d-none d-sm-inline">Painéis de Dados </span>
				<!-- <span class="d-none d-sm-inline" v-else>Nova </span> -->
			</v-toolbar-title>
				
		<template v-slot:extension>

		<v-tabs v-model="tab" centered dark icons-and-text>
			<v-tabs-slider></v-tabs-slider>

			<v-tab href="#tab1">
				Geral
				<v-icon>mdi-cash-lock</v-icon>
			</v-tab>

			<v-tab href="#tab2">
				Empenhos
				<v-icon>mdi-cash-multiple</v-icon>
			</v-tab>

			<v-tab href="#tab3">
				Emendas
				<v-icon>mdi-cash-multiple</v-icon>
			</v-tab>

			<v-tab href="#tab4">
				Dotações
				<v-icon>mdi-cash-multiple</v-icon>
			</v-tab>

			<v-tab href="#tab5">
				CPL's
				<v-icon>mdi-cash-multiple</v-icon>
			</v-tab>

			<v-tab href="#tab6">
				Obras
				<v-icon>mdi-shovel</v-icon>
			</v-tab>
		</v-tabs>
	</template>
	</v-app-bar>

	
		<v-tabs-items v-model="tab">
			<v-tab-item value="tab1">
				<iframe 
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/dashboard/05790aeb-4de2-4c09-80a0-c52b66b7e000" 
					frameborder="0" 
					width="1150"
					height="600" 
					allowtransparency>
				</iframe>
			</v-tab-item>

			<v-tab-item value="tab2">
				<iframe 
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/question/859c9ba2-734e-4583-a8c1-4bf47d418a4d" 
					frameborder="0" 
					width="1150"
					height="600" 
					allowtransparency>
				</iframe>
			</v-tab-item>

			<v-tab-item value="tab3">
				<iframe 
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/question/c2f3d12e-cef4-4191-b352-9aa16ffed858" 
					frameborder="0" 
					width="1150"
					height="600" 
					allowtransparency>
				</iframe>
			</v-tab-item>

			<v-tab-item value="tab4">
				<iframe 
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/question/2bc6f9b6-a554-4aee-afbc-26075def286a" 
					frameborder="0" 
					width="1150"
					height="600" 
					allowtransparency>
				</iframe>
			</v-tab-item>

			<v-tab-item value="tab5">
				<iframe 
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/question/b9b9b0a4-f55d-449d-95f3-bc7ec43ae59a" 
					frameborder="0" 
					width="1150"
					height="600" 
					allowtransparency>
				</iframe>
			</v-tab-item>

			<v-tab-item value="tab6">
				<iframe 
					src="https://servicos.sorocaba.sp.gov.br/metabase/public/question/2bbe3b64-314f-4cf6-b2e0-04a08708e72d" 
					frameborder="0" 
					width="1150"
					height="600" 
					allowtransparency>
				</iframe>
			</v-tab-item>
			
		</v-tabs-items>

	</v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
//import VPageHeader from '@/components/PageHeader.vue';

export default {
	name: 'Home',
	data() {
		return {
			tab: 'tabGeral'		
		};
	},
	//components: {VPageHeader},
	async created() {
		this.fetchEsferaItems();
		//this.fetchSituacoesItems();     //??
		this.fetchSecretarias();
		this.fetchSituacoes();
		this.fetchParlamentares();

		this.$root.colorHeader = "blue";
		this.$root.titleHeader = "Painéis do Metabase";

		this.anoExercicio = this.$root.anoSelecionado;
	},


	computed: {
		emendasSelecionadasSituacao() {
			if (this.despachoSituacao && this.despachoSituacao.id) {
				return this.emendasSelecionadas.filter(
					e => e.situacao.id == this.despachoSituacao.id
				);
			}

			return [];
		}
	},
	watch: {
		// esfera(val) {
		// 	let id = val && val.id;
		// 	this.fetchAnos(id);
		// },

		'$root.anoSelecionado'() {
			this.anoExercicio = this.$root.anoSelecionado;
			this.fetchEmendas();
		},

		esfera() {
			this.fetchEmendas();
		},
		anoExercicio() {
			this.fetchEmendas();
		},
		secretarias() {
			this.fetchEmendas();
		},
		situacoes() {
			this.fetchEmendas();
		},
		numeroEmendaPesq() {
			this.fetchEmendas();
		},
		parlamentares() {
			this.fetchEmendas();
		},
		searchText() {
			this.page = 1;
		}
	},
	methods: {
		novo() {
			this.$router.push('/emendas/novo');
		},
		rowClick(item) {
			this.$router.push(`/emendas/${item.id}`);
		},
		async fetchEmendas() {
			try {
				let emendas = await this.$fetch.get('emendas', {
					anoExercicio: this.anoExercicio,
					idEsfera: this.esfera ? this.esfera.id : null,
					idSecretaria: this.secretarias ? this.secretarias.id : null,
					idSituacao: this.situacoes ? this.situacoes.id : null,
					nrEmenda: this.numeroEmendaPesq ? this.numeroEmendaPesq : null ,
					idParlamentarExercicio : this.parlamentares ? this.parlamentares.id : null
				});
				
				emendas.forEach(emenda => {
					emenda.valor$ = this.setMascara(emenda.valor);
					emenda.valorFixadoFinal$ = this.setMascara(emenda.valorFixadoFinal);
					if (
						this.$root.usuarioLogado &&
						this.$root.usuarioLogado.funcoes &&
						this.$root.usuarioLogado.funcoes.includes('EMENDA_ALTERAR')
					) {
						emenda.isSelectable = true;
					} else if (emenda.situacao.id === 3) {
						emenda.isSelectable = true;
					} else {
						emenda.isSelectable = false;
					}
				});
				this.emendas = emendas;

			} catch (err) {
				this.noDataMessage = err.msg;
			}
		},
		async fetchEsferaItems() {
			try {
				this.esferaItems = await this.$fetch.get('parlamentares/esferas');
				this.esferaItems.splice(0, 0, { id: null, descricao: 'Todos' });
				this.esfera = this.esferaItems[0];
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar esferas',
					msg: err.msg
				};
			}
		},

		// async fetchSituacoesItems() {
		// 	try {
		// 		this.situacaoItems = await this.$fetch.get('emendas/situacoes');
		// 	} catch (err) {
		// 		this.$root.dialog = {
		// 			title: 'Não foi possível carregar situações',
		// 			msg: err.msg
		// 		};
		// 	}
		// },

		async fetchSituacoesDestinoItems(idFluxoOrigem) {
			try {
				this.situacaoFluxoDestinoItems = await this.$fetch.get('emendas/situacoesFluxoDestino', {
					idFluxoOrigem
			});
			} catch (err) {
				this.$root.dialog = {
					title: 'Não foi possível carregar situações',
					msg: err.msg
				};
			}
		},

		// async fetchAnos(idEsfera) {
		// 	this.anoExercicioItems = await this.$fetch.get('emendas/anos', {
		// 		idEsfera
		// 	});
		// 	this.anoExercicioItems.splice(0, 0, { anoExercicio: 'Todos' });
		// 	this.anoExercicio = this.anoExercicioItems[0];
		// 	this.fetchEmendas();
		// },

		async fetchSecretarias() {
			this.secretariaItems = await this.$fetch.get('emendas/secretarias');
			// if (this.$root.usuarioLogado &&
			// 		this.$root.usuarioLogado.perfis &&
			// 		this.$root.usuarioLogado.perfis.includes('Administrador')) {
				this.secretariaItems.splice(0, 0, { id: null, nome: 'Todas' });
			// }
			this.secretarias = this.secretariaItems[0];
			this.fetchEmendas();
		},

		async fetchSituacoes() {
			this.situacaoItems = await this.$fetch.get('emendas/situacoes');
			this.situacaoItems.splice(0, 0, { id: null, descricao: 'Todas' });
			// if (this.$root.usuarioLogado &&
			// 		this.$root.usuarioLogado.perfis &&
			// 		this.$root.usuarioLogado.perfis.includes('Administrador')) {
				this.situacoes = this.situacaoItems[0];
			// }
			// else
			// 	this.situacoes = this.situacaoItems.find( a => a.id === 3 );
			this.fetchEmendas();
		},

		async fetchParlamentares() {
			this.parlamentaresItems = await this.$fetch.get('emendas/parlamentares');

			for (let index = 0; index < this.parlamentaresItems.length - 1; index++) {
				this.parlamentaresItems[index].nome = 
					this.parlamentaresItems[index].nome  + ' - ' +
					this.parlamentaresItems[index].dataInicio + ' a ' +
					this.parlamentaresItems[index].dataFim;
			}

			this.parlamentaresItems.splice(0, 0, { id: null, nome: 'Todos' });
			// if (this.$root.usuarioLogado &&
			// 		this.$root.usuarioLogado.perfis &&
			// 		this.$root.usuarioLogado.perfis.includes('Administrador')) {
				this.parlamentares = this.parlamentaresItems[0];
			// }
			// else
			// 	this.situacoes = this.situacaoItems.find( a => a.id === 3 );
			this.fetchEmendas();
		},

		setMascara(v) {
			if (v >= 0) {
				return v.toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
					style: 'currency',
					currency: 'BRL'
				});
			}
			return '-';
		},

		customSort(items, index, isDesc) {
			items.sort((a, b) => {
				if (index[0] && index[0].slice(-1) === '$') {
					if (!isDesc[0]) {
						return a[index[0].slice(0, -1)] < b[index[0].slice(0, -1)] ? -1 : 1;
					} else {
						return b[index[0].slice(0, -1)] < a[index[0].slice(0, -1)] ? -1 : 1;
					}
				} else if (a[index]) {
					if (!isDesc[0]) {
						return a[index] < b[index] ? -1 : 1;
					} else {
						return b[index] < a[index] ? -1 : 1;
					}
				}
				else {
					// campos "filhos" tem que fazer a ordenação na mão
					if ((index[0] == 'situacao.descricao') || (index[0] == 'secretaria.sigla'))
					{
						var campoA, campoB, ordem;

						if (index[0] == 'situacao.descricao')
						{
							campoA = a['situacao'];
							campoB = b['situacao'];

							ordem = 'descricao';
						}

						if (index[0] == 'secretaria.sigla')
						{
							campoA = a['secretaria'];
							campoB = b['secretaria'];

							ordem = 'sigla'
						}

						if (!isDesc[0]) {
							return campoA[ordem].toLowerCase().localeCompare(campoB[ordem].toLowerCase());
						} else
						{
							return campoB[ordem].toLowerCase().localeCompare(campoA[ordem].toLowerCase());
						}
					}
				}
			});

			return items;
		},

		//async clickTramitar(emendasSelecionadas) {

			//let situacaoEmendas = [];

			// montar uma array só com o campo situação
			//emendasSelecionadas.forEach((sit) => { situacaoEmendas.push(sit.situacao.id) });

			// verificando se foram selecionadas emendas com situações diferentes
			// var idSituacao = situacaoEmendas.filter(function(elem, pos, arr) {
			// 	return arr.indexOf(elem) == pos;
			// });

			//let mesmaSituacao = (idSituacao.length === 1); 
			
			// if (mesmaSituacao)
			// {
			// 	if ( (emendasSelecionadas.length == 1) || ( (this.$root.usuarioLogado &&
			// 			this.$root.usuarioLogado.funcoes &&
			// 			this.$root.usuarioLogado.funcoes.includes('EMENDA_ALTERAR')) ) ) {
			// 		this.fetchSituacoesDestinoItems(idSituacao);
			// 		this.exibirTramitacao = true;
			// 	} else {
			// 		this.$root.dialog = { title: 'Tramitação não permitida', msg: 'Selecione somente uma emenda para tramitação por vez.' };
			// 	}
			// }
			// else {
			// 	this.$root.dialog = { title: 'Tramitação não permitida', msg: 'Selecione somente emendas na mesma situação.' };
			// }

		//},

		async tramitar() {
			await this.$refs.formDespacho.validate();

			if (this.despachoValido) {
				let emendasTramitar = this.emendasSelecionadas
					.filter(e => e.situacao.id !== this.despachoSituacao.id)
					.map(e => e.id);
				let tramitacao = {
					despacho: this.despacho,
					emendasTramitar,
					situacao: this.despachoSituacao
				};

				this.exibirTramitacao = false;

				try {
					let qtdEmendasSalvas = await this.$fetch.post(
						`emendas/tramitar`,
						tramitacao
					);

					this.$emit('snack', {
						show: true,
						text: `${qtdEmendasSalvas} emendas tramitadas com sucesso para ${this.despachoSituacao.descricao}`
					});

					await this.resetTramitacao();

					this.fetchEmendas();
				} catch (err) {
					this.$root.dialog = { title: 'Emenda não salva', msg: err.msg };
				}
			}
		},

		async cancelarTramitacao() {
			await this.resetTramitacao();

			this.exibirTramitacao = false;
		},

		async resetTramitacao() {
			this.despacho = null;
			this.despachoSituacao = null;
			await this.$refs.formDespacho.reset();
		},

		temFuncao(fn) {
			return (
				this.$root.usuarioLogado &&
				this.$root.usuarioLogado.funcoes &&
				this.$root.usuarioLogado.funcoes.includes(fn)
			);
		}
	}
};
</script>

<style scoped>
.head-tile {
	margin: -10px -10px 0 -10px;
}
.row-pointer >>> tbody tr :hover {
	cursor: pointer;
}
.situacao {
	font-weight: bold;
	color: orangered;
}
.emendas {
	font-weight: bold;
	color: purple;
}
.info-despacho {
	text-align: center;
	font-size: 80%;
}
</style>
